@if (state() === 'up') {
	<span class="position-change-chip gain" aria-label="Position gained">
		<span class="position-change-arrow" aria-hidden="true">
			<i class="bi bi-caret-up-fill"></i>
		</span>
	</span>
} @else if (state() === 'down') {
	<span class="position-change-chip loss" aria-label="Position lost">
		<span class="position-change-arrow" aria-hidden="true">
			<i class="bi bi-caret-down-fill"></i>
		</span>
	</span>
}
